import React, { useContext } from "react";
import { ProjectContext } from "../../context/project_context";

const ProjectSplitVideo = () => {
  const { project, updateProject } = useContext(ProjectContext);

  const handleSkip = async () => {
    await updateProject({
      ...project,
      project_status: "grab_audio" // Replace with your actual next status
    });
  };

  return (
    <div className="split-video-container">
      <h2>Split Video</h2>
      <div className="split-video-content">
        {/* Add your split video functionality here */}
        <p>Video splitting functionality will be implemented here</p>
        <button 
          className="btn btn-secondary mt-3"
          onClick={handleSkip}
        >
          Skip Video Splitting
        </button>
      </div>
    </div>
  );
};

export default ProjectSplitVideo; 